import {Navigate} from 'react-router-dom';

import {routes} from '../../common/constants/routes';

export default function AdminPortal(): JSX.Element {
  return <Navigate to={routes.adminPortal.scormTemplates} replace />;
}
